import * as React from "react";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import * as Constants from '../../../common/constants';
import { TabMenu } from 'primereact/tabmenu';
import { Route } from "react-router-dom";
import LoadDataContainer from './loadDataContainer';
import ImportDataContainer from './importDataContainer';
import SyncSchedulerContainer from './syncSchedulerContainer';

interface IProps {
  match: any,
  history: any
}

interface IState {
  isLoading: boolean;
  error: any;
  isVisibleConfirmDialog: boolean;
  validationMessage: string;
  menuItems: any;
  activeTabItem: any;
}

class DataSynchronizationContainer extends React.Component<IProps, IState> {
  growl: any;
  redirect: boolean;

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      validationMessage: '',
      isLoading: false,
      isVisibleConfirmDialog: false,
      menuItems: [],
      activeTabItem: {},
    };
  }

  componentDidMount() {
    this.initializeTabmenu();
  }

  initializeTabmenu() {

    let currentTabObjects: Array<tabMenuItem> = [
      { label: 'Load', icon: 'pi pi-file', tabRouteName: 'loadData' },
      { label: 'Import & Synchronize', icon: 'pi pi-download', tabRouteName: 'importSyncData' },
      { label: 'Scheduler', icon: 'pi pi-clock', tabRouteName: 'syncScheduler' }
    ]

    let activeItem = this.props.match.params.TabName ?
      currentTabObjects.find(i => i.tabRouteName == this.props.match.params.TabName) :
      currentTabObjects.find(i => i.tabRouteName == 'loadData');

    this.setState({
      isLoading: false,
      menuItems: currentTabObjects,
      activeTabItem: activeItem
    });
  }

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  showEditDialog = (show: boolean) => {
    this.setState({
      validationMessage: ''
    })
  };

  handleTabMenuchange = (value) => {
    this.props.history.push(`/data/emaSync/${value.tabRouteName}`);
  }

  public render() {
    const { isLoading, error } = this.state;

    let activeItem = this.props.match.params.TabName ?
      this.state.menuItems.find(i => i.tabRouteName == this.props.match.params.TabName) :
      this.state.menuItems.find(i => i.tabRouteName == 'loadData');

    return (
      <>
        <div>
          <h3>EMA data synchronization</h3>
          {isLoading ? <Spinner /> : null}
          {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}
          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          <Growl ref={(el) => this.growl = el} />
          <TabMenu
            model={this.state.menuItems}
            activeItem={activeItem}
            onTabChange={(e) => this.handleTabMenuchange(e.value)}
          />
          <Route exact path={`/data/emaSync/`} component={CurrentTabPage} />
          <Route exact path={`/data/emaSync/:TabName/`} component={CurrentTabPage} />
        </div >
      </>
    );
  }
}

class tabMenuItem {
  label: string;
  icon: string;
  tabRouteName: string;
}

const CurrentTabPage = (props) => {
  let params = props.match.params;
  let tabName = params.TabName ? params.TabName : 'loadData';

  switch (tabName) {
    case 'loadData':
      return <LoadDataContainer />;
    case 'importSyncData':
      return <ImportDataContainer />;
    case 'syncScheduler':
      return <SyncSchedulerContainer />;
    default:
      return null;
  }
}

export default DataSynchronizationContainer;